import { render, staticRenderFns } from "./story_index.vue?vue&type=template&id=00418c1a&scoped=true&"
import script from "./story_index.vue?vue&type=script&lang=js&"
export * from "./story_index.vue?vue&type=script&lang=js&"
import style0 from "./story_index.vue?vue&type=style&index=0&id=00418c1a&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "00418c1a",
  null
  
)

export default component.exports